//动态路由
import Layout from '../../pages/layout';
// 地锁停车
export default [
  {
    path: '/groundpark/p',
    component: Layout,
    meta: { title: '停车管理', icon: 'parking' },
    children: [
      {
        path: 'record',
        component: require('@/pages/ground-parking/park-record/park-record'),
        name: 'record',
        meta: {
          title: '停车记录',
          roles: [2]
        }
      }
    ]
  },
  {
    path: '/groundpark/f',
    component: Layout,
    meta: {
      title: '支付结算',
      icon: 'finance'
    },
    children: [
      {
        path: 'payrecord',
        component: require('@/pages/ground-parking/pay-record/pay-record'),
        name: 'pay-record',
        meta: { title: '支付记录', roles: [2] }
      }]
  },
];


// WEBPACK FOOTER //
// ./src/router/ground-parking/index.js